/** The booking column piece, standard look over its behavior half. */
import { BookingColumnView } from './BookingColumnView';
import { useBookingColumn, type BookingColumnInput } from './useBookingColumn';

export function BookingColumn(props: BookingColumnInput) {
  return <BookingColumnView {...useBookingColumn(props)} />;
}
